// Literal JSON keys win (for example "parent.id"); otherwise resolve an own-property path.
// Shared by chart and bar-list bindings. Never read properties inherited from prototypes.
export function readDataField(row: unknown, path: string): unknown {
    if (!row || typeof row !== 'object') return undefined
    if (Object.prototype.hasOwnProperty.call(row, path)) return (row as Record<string, unknown>)[path]
    let current: unknown = row
    for (const part of path.split('.')) {
        if (!part || !current || typeof current !== 'object' || !Object.prototype.hasOwnProperty.call(current, part)) return undefined
        current = (current as Record<string, unknown>)[part]
    }
    return current
}
